import { Record } from 'immutable';
import { reviveRecord } from 'utils/immutable';

import { EddyState, State } from './types';

export const stateFactory = Record<State>({
  eddyProject: undefined,
  pollStatus: undefined,
});

export function stateFromJs(obj: any): EddyState {
  return reviveRecord(stateFactory, obj);
}
